// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b9f1872","455":"5dbb6fbd"}[chunkId] + ".chunk.js";
};